// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"179":"1cd02d44","427":"65e9c885","594":"7fdba27e"}[chunkId] + ".js";
};